import styled from 'styled-components';

import backgroundImage from '../../assets/images/background.jpg';
import overlayImage from '../../assets/images/overlay.png';

const Background = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background-image: url(${overlayImage}), url(${backgroundImage});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% 50%;
`;

export { Background };
